document.addEventListener('update', (event) => {
  const listener = event.target;
  if (!(listener instanceof HTMLElement) || listener.tagName !== 'PRODUCT-VARIANT-LISTENER') return;
  const purchaseForm = listener.closest('.dio-stable-purchase-options');
  if (!purchaseForm || listener.id !== 'b-buttons') return;
  const variantId = listener.querySelector('product-to-cart')?.getAttribute('variant-id');
  if (!variantId || variantId === purchaseForm.dataset.dioVariant) return;
  purchaseForm.dataset.dioVariant = variantId;
  queueMicrotask(() => {
    if (!listener.isConnected || listener.querySelector('.appstle_sub_widget')) return;
    if (typeof window.appstleInit === 'function') window.appstleInit();
  });
});
